import React, { useState, useEffect } from "react";
import "./index.css";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookie_consent", "rejected");
    setShowBanner(false);
  };


  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <h3>Your privacy, your choice</h3>
        <p>
          We use cookies to enhance your experience, personalize content,
          and analyze our traffic.
          .
        </p>
        <div className="cookie-buttons">
          <button className="reject" onClick={handleReject}>
            Reject
          </button>
          <button className="accept" onClick={handleAccept}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
